/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      //console.log('Container ———————— ↓');
      //console.log(container);
      //console.log('Variant —————————— ↓');
      //console.log(variant);
      // ... update some element on the page
    }
  });


$(document).on("change",".template-collection .boost-pfs-variant-selector ",function(e){
  var id = $(this).val();
  $(this).parents(".boost-pfs-filter-product-bottom").find("form[action='/cart/add'] input[name='id']").val(id);
});
  
$(document).on("click",".template-collection form[action='/cart/add']",function(e){
  e.preventDefault();
  var viid = $(this).find("input[name='id']").val();
  $.ajax({
  type: 'POST',
  url: '/cart/add.js',
  data: {
    quantity: 1,
    id: viid
  },
  dataType: 'json', 
  success: function (variant) { 
    //console.log(variant);
  document.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: {
  variant: variant,
  },bubbles: true}));
  $.ajax({
    url:	"/cart.json",
    type:	'GET'
  })
  .done(function(data) {
    $("[data-header-cart-count]").text(data.item_count);
  })
  .fail(function(data) {})
  .always(function(data) {});
  } 
  });
});

  $(document).on('change', '.collection-variant-dropdown', function(){
    var d, p, cp;
    d = $(this).find('option:selected').attr('data-v-discount');
    p = $(this).find('option:selected').attr('data-price');
    cp = $(this).find('option:selected').attr('data-v-compare-price');
    
    if(d){
    $(this).parents('.boost-pfs-filter-product-item').find('.sale').html(d+'%');
    }
    if(cp){
      $(this).parents('.boost-pfs-filter-product-item').find('.boost-pfs-filter-product-item-sale-price').html(p);
      $(this).parents('.boost-pfs-filter-product-item').find('.boost-pfs-filter-product-item-price s').html(cp);
    }else{
      $(this).parents('.boost-pfs-filter-product-item').find('.boost-pfs-filter-product-item-regular-price').html(p);
    }
  })
  
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      //console.log('Cart ———————————— ↓');
      //console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    //console.log('theme:cart:init');
   // console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

var photoSection = document.querySelector('#shopify-section-press');
var photoItem = photoSection.querySelectorAll('.grid__item img');
var modalSection = document.querySelector('.modal-overlay');
var modalPart = document.querySelector('.modal');

var closeModal = document.querySelector('.close-modal');
var modalContent = document.querySelector('.modal-content');
var modalImage = document.querySelector('.modal-image');
var imageSrc;
var imageTitle
var modalImageItem = document.querySelector('.modal-image-item');
var modalImageTitle = document.querySelector('.modal-image-title');

photoItem.forEach(item => {
  item.addEventListener('click', function(){ 
    imageSrc = item.getAttribute('src');
    imageTitle = item.getAttribute('title');
    //console.log(modalImageItem)
    modalImageItem.setAttribute('src', imageSrc);
    modalImageTitle.innerHTML = imageTitle;
    modalSection.classList.add('active');
    modalPart.classList.add('active'); 
  })
})

  
 

 
  document.querySelector('.endmodal').addEventListener('click', function(){
    if (modalSection.classList.contains('active')) {
      modalSection.classList.remove('active');
      modalPart.classList.remove('active');
    
    }
  })

  
  
  

  

